<template>
  <div class="ml-3">
    <div class="ml-2 mb-2">
      <span class="orange-icon orange-icon-badge-align fa fa-info-circle" />
      <strong class="py-2 pl-2 font-16">Información Adicional</strong>
    </div>
    <div class="ml-md-3 pl-md-2 mr-md-3 mt-md-4 mb-md-4 bg-white">
      <div class="row p-md-2 container-info">
        <div class="col-md-2 col-sm-12">
          <span class="data-title d-block border-mobile">
            Número de Solicitud:
          </span>
          <span class="font-16 color-black">
            <strong>{{ data.requestNumber }}</strong>
          </span>
        </div>
        <div v-if="data.modality" class="col-md-2 col-sm-12">
          <span class="data-title d-block">Modalidad:</span>
          <span class="font-16 color-black">
            {{ data.modality }}
          </span>
        </div>
        <div v-if="data.frequency" class="col-md-2 col-sm-12">
          <span class="data-title d-block border-mobile">Frecuencia:</span>
          <span class="font-16 color-black">
            {{ data.frequency }}
          </span>
        </div>
        <div v-if="data.duration" class="col-md-2 col-sm-12">
          <span class="data-title d-block border-mobile">Duración :</span>
          <span class="font-16 color-black">
            {{ data.duration }}
          </span>
        </div>

        <div class="col-md-4 col-sm-12">
          <span class="data-title d-block border-mobile">
            Lugar de Servicio:
          </span>
          <span class="font-16 color-black">
            {{ serviceAddress }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AditionalInformation',
  components: {},
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  computed: {
    serviceAddress() {
      const { locationService } = this.data;

      return locationService ?? '-';
    },
  },
  methods: {
    openCloseTabs() {
      this.showTabs = !this.showTabs;
    },
  },
};
</script>

<style lang="scss" scoped>
.container-info {
  position: relative;
  top: -15px;
}
.orange-icon {
  color: #ff7058;
}
</style>
